import { addMethod, string } from 'yup';

addMethod(string, 'telephone', function telephone(message = 'must be a valid phone number') {
  return this.test('telephone', message, value => {
    if (!value) return true;
    return /^((\+[1-9]{1,4}[ -]*)|(\([0-9]{2,3}\)[ -]*)|([0-9]{2,4})[ -]*)*?[0-9]{3,4}?[ -]*[0-9]{3,4}?$/.test(value);
  });
});
